import { render, staticRenderFns } from "./CollectionRegister.vue?vue&type=template&id=4d53c2db&"
import script from "./CollectionRegister.vue?vue&type=script&lang=js&"
export * from "./CollectionRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports